/**
 * Tondo: the round picture in the bowl of an Athenian drinking cup. Here it is
 * the emblem of an evening: a black-glazed disc, a ring of Greek key, and the
 * one object that evening turns on (motifs.jsx).
 *
 * Decorative by default, because wherever it appears the evening's title sits
 * beside it. Pass `label` where it stands alone.
 */
import React from 'react';
import { EVENING_MOTIFS, CLAY, GLAZE } from './motifs';

// One hook of the key, drawn at the top of the ring and turned round the centre.
const KEYS = 28;
const key = 'M-3 -45.4 V-51.4 H2.4 V-47.6 H-1 V-49.4 H0.6';

// Below this size the key is too fine to read, so the ring is left plain and
// the motif is given the room instead.
const PLAIN_BELOW = 72;

const Tondo = ({ evening, size = 64, label, className, children }) => {
  const Motif = EVENING_MOTIFS[evening];
  const plain = size < PLAIN_BELOW;
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true };

  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={className}
      focusable="false"
      {...a11y}
    >
      <circle cx={60} cy={60} r={59} fill={GLAZE} />
      <circle cx={60} cy={60} r={56.4} fill="none" stroke={CLAY} strokeWidth={plain ? 2.4 : 1.6} />
      {!plain && (
        <>
          <circle cx={60} cy={60} r={45.4} fill="none" stroke={CLAY} strokeWidth={1.1} />
          <g transform="translate(60 60)" fill="none" stroke={CLAY} strokeWidth={1.1} strokeLinejoin="miter">
            {Array.from({ length: KEYS }, (_, i) => (
              <path key={i} d={key} transform={`rotate(${(i * 360) / KEYS})`} />
            ))}
          </g>
        </>
      )}
      {/* the motif is drawn for the whole field, so bring it inside the ring */}
      <g transform={`translate(60 60) scale(${plain ? 1.12 : 0.8}) translate(-60 -60)`}>
        {Motif ? <Motif /> : children}
      </g>
    </svg>
  );
};

export default Tondo;
